import React from 'react';
import { MessageCircle, FileText, ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToLeadForm = () => {
    const element = document.getElementById('lead-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="pt-32 pb-8 bg-gradient-to-br from-teal-50 via-white to-amber-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%230F766E' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h1 className="text-5xl lg:text-7xl font-bold leading-tight text-gray-900 mb-6">
            Jabalpur's Largest
            <span className="text-primary block mt-2">Fabric Wholesaler</span>
            <span className="text-accent"> Best Prices in MP</span>
          </h1>

          {/* Description */}
          <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed mb-8">
            <span className="font-bold text-primary">Wholesale Supplier</span> of 2-Way, 4-Way, Zurich, Superpoly, Hosiery & Sportswear Fabrics
            <span className="block mt-3 text-lg">Retail options also available | All colors in stock</span>
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <a
              href={`https://wa.me/919713889720?text=${encodeURIComponent('Hello, I want fabric details and rates')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary btn-lg flex items-center gap-2 group"
            >
              <MessageCircle size={22} />
              WhatsApp Now
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>

            <button
              onClick={scrollToLeadForm}
              className="btn-secondary btn-lg flex items-center gap-2"
            >
              <FileText size={22} />
              Request Quote
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
